import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

interface AlertContent {
    title?: string;
    content: string | string[];
}

type AlertState = {
    errorMessage: AlertContent | null;
    successMessage: AlertContent | null;
};

const initialState = { errorMessage: null, successMessage: null } as AlertState;

const slice = createSlice({
    name: "commonAlertSlice",
    initialState,
    reducers: {
        setErrorMessage: (state, { payload }: PayloadAction<AlertContent | null>) => {
            state.errorMessage = payload;
        },
        setSuccessMessage: (state, { payload }: PayloadAction<AlertContent | null>) => {
            state.successMessage = payload;
        },
        clearAlerts: (state) => {
            state.errorMessage = null;
            state.successMessage = null;
        },
    },
});

export const { setErrorMessage, setSuccessMessage, clearAlerts } = slice.actions;

export default slice.reducer;

export const selectErrorMessage = (state: RootState) => state.commonAlertSlice.errorMessage;
export const selectSuccessMessage = (state: RootState) => state.commonAlertSlice.successMessage;
